<script setup lang="ts">
import { Moon, Sun } from 'lucide-vue-next'
import { useTheme } from '@/composables/useTheme'

const { theme, toggleTheme } = useTheme()
</script>

<template>
  <button
    type="button"
    class="flex size-9 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-brand-500/30 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-200"
    :aria-label="theme === 'dark' ? 'Prepnúť na svetlý režim' : 'Prepnúť na tmavý režim'"
    :title="theme === 'dark' ? 'Svetlý režim' : 'Tmavý režim'"
    @click="toggleTheme"
  >
    <Moon v-if="theme === 'dark'" class="size-5 stroke-[1.5px]" aria-hidden="true" />
    <Sun v-else class="size-5 stroke-[1.5px]" aria-hidden="true" />
  </button>
</template>
